import { brand } from "@/lib/site";

// Renders the current domain's logo + wordmark. `size` controls the icon; the
// wordmark text size is set by the caller via `textClass`.
export default function BrandLogo({
    size = 36,
    textClass = "font-serif text-2xl font-semibold text-secondary",
    accentClass = "text-xs uppercase tracking-widest text-primary",
    showText = true,
    className = "",
}) {
    const [main, accent] = brand.wordmark;
    return (
        <span className={`flex items-center gap-2.5 ${className}`}>
            <img
                src={brand.logo}
                alt={brand.name}
                width={size}
                height={size}
                className="shrink-0"
                style={{ width: size, height: size }}
            />
            {showText && (
                <span className="flex items-baseline gap-1.5">
                    <span className={textClass}>{main}</span>
                    <span className={accentClass}>{accent}</span>
                </span>
            )}
        </span>
    );
}
